import { ActionTree, createNamespacedHelpers } from "vuex";
import {
    activationRepository,
    activationCommentRepository,
    activationtypeRepository,
    activationcaseRepository,
    activationcreateRepository,
    marketRepository,
    userRepository,
    influencerRepository,
} from "@/repositories";
import {
    dashboardRepository,
    prAffiliateRepository,
    brandRepository,
    brandQualityRepository,
    keywordRepository,
    hashtagRepository,
    entityRepository,
    entityTypeRepository,
    roleRepository,
    uploadFileRepository,
} from "@/repositories";
import { IAppState } from "./state";
import * as mutations from "./mutations-types";

import {
    IUser,
    IActivationCreate,
    IActivation,
    IBrandCreate,
    IBrandQualityCreate,
    IMarketCreate,
    IInfluencerCreate,
    IActivationAccessUpdate,
    IActivationComment,
    IActivationUser,
    IActivationUserPermission,
    IUpsertActivationUsers,
    IPrAffiliate,
    IPrAffiliateCreate,
} from "@/models";
import { IUploadFile } from "@/models/IUploadFile";

export const actions: ActionTree<IAppState, any> = {
    addUser: async (context, payload: IUser): Promise<void> => {
        const user = await userRepository.add(payload);

        context.commit(mutations.ADD_USER, user);
    },
    sendRequestAccess: async (context, payload: IUser): Promise<void> => {
        const user = await userRepository.sendRequestAccess(payload);

        context.commit(mutations.ADD_USER, user);
    },

    updateUser: async (context, payload: IUser): Promise<void> => {
        const user = await userRepository.update(payload, `/${payload.userId}`);

        context.commit(mutations.UPDATE_USER, user);
    },

    loadUsers: async (context, includeInactive: boolean): Promise<void> => {
        const users = await userRepository.getAll({
            includeInactive,
        });

        context.commit(mutations.SET_USERS, users);
    },
    loadEntities: async (context): Promise<void> => {
        const entities = await entityRepository.getAll();

        context.commit(mutations.SET_ENTITIES, entities);
    },
    loadEntityTypes: async (context): Promise<void> => {
        const entityTypes = await entityTypeRepository.getAll();

        context.commit(mutations.SET_ENTITY_TYPES, entityTypes);
    },
    loadRoles: async (context): Promise<void> => {
        const roles = await roleRepository.getAll();

        context.commit(mutations.SET_ROLES, roles);
    },
    loadUnauthorizeRoles: async (context): Promise<void> => {
        const roles = await roleRepository.getUnautorizeRoles();

        context.commit(mutations.SET_UNAUTHORIZE_ROLES, roles);
    },
    loadAllActivationType: async (context): Promise<void> => {
        const activationtype = await activationtypeRepository.getAll();

        context.commit(mutations.ACTIVATION_TYPE, activationtype);
    },
    loadAllActivationCase: async (context): Promise<void> => {
        const activationcase = await activationcaseRepository.getAll();

        context.commit(mutations.ACTIVATION_CASE, activationcase);
    },
    loadAllMarket: async (context): Promise<void> => {
        const market = await marketRepository.getAll();

        context.commit(mutations.ACTIVATION_MARKET, market);
    },
    createMarket: async (context, market: IMarketCreate): Promise<void> => {
        const createdMarket = await marketRepository.add(market);
        context.commit(mutations.ADD_MARKET, createdMarket);
    },
    loadAllBrand: async (context): Promise<void> => {
        const brand = await brandRepository.getAll();

        context.commit(mutations.ACTIVATION_BRAND, brand);
    },
    loadAllBrandQuality: async (context): Promise<void> => {
        const brandsQuality = await brandQualityRepository.getAll();

        context.commit(mutations.ACTIVATION_BRAND_QUALITY, brandsQuality);
    },
    loadAllPrAffiliate: async (context): Promise<void> => {
        const prAffiliate = await prAffiliateRepository.getAll();

        context.commit(mutations.ACTIVATION_PR_AFFILIATE, prAffiliate);
    },
    createPrAffiliate: async (context, prAffiliate: IPrAffiliateCreate): Promise<void> => {
        const createdPrAffiliate = await prAffiliateRepository.add(prAffiliate);
        context.commit(mutations.ADD_PR_AFFILIATE, createdPrAffiliate);
    },
    createBrand: async (context, brand: IBrandCreate): Promise<void> => {
        const createdBrand = await brandRepository.add(brand);
        context.commit(mutations.ADD_BRAND, createdBrand);
    },

    createBrandQuality: async (context, brandQuality: IBrandQualityCreate): Promise<void> => {
        const createdBrandQuality = await brandQualityRepository.add(brandQuality);
        context.commit(mutations.ADD_BRANDQUALITY, createdBrandQuality);
    },
    loadAllInfluencers: async (context): Promise<void> => {
        const influencers = await influencerRepository.getAll();
        context.commit(mutations.SET_INFLUENCERS, influencers);
    },
    // TODO change repo
    loadInfluencerTemplate: async (context): Promise<void> => {
        const template = await activationRepository.getInfluencersFileTemplate();
        context.commit(mutations.GET_INFLUENCERS_FILE_TEMPLATE, template.data);
    },
    // TODO change repo
    // TODO Change GET verbe by Load?
    loadInfluencers: async (context, blobName: string): Promise<void> => {
        const influencers = await activationRepository.getInfluencersFile(blobName);
        context.commit(mutations.GET_INFLUENCERS_FILE, influencers.data);
    },
    // TODO change repo
    resetInfluencers: (context): void => {
        context.commit(mutations.RESET_INFLUENCERS_FILE);
    },
    createInfluencer: async (context, influencerCreate: IInfluencerCreate): Promise<void> => {
        const createdInfluencer = await influencerRepository.add(influencerCreate);
        context.commit(mutations.ADD_INFLUENCER, createdInfluencer);
    },
    loadActivationByUser: async (
        context,
        UserUniqueId: string,
    ): Promise<void> => {
        context.commit(mutations.CLEAR_DASHBOARD);
        const dashboard: IActivation[] = await dashboardRepository.getActivationByUser(
            UserUniqueId,
        );
        context.commit(mutations.LOAD_ACTIVATIONCREATE, dashboard);
    },
    loadPastActivation: async (
        context,
        UserUniqueId: string,
    ): Promise<void> => {
        context.commit(mutations.CLEAR_DASHBOARD);
        const dashboard: IActivation[] = await dashboardRepository.getPastActivationByUser(
            UserUniqueId,
        );

        context.commit(mutations.LOAD_ACTIVATIONCREATE, dashboard);
    },
    loadActivationById: async (
        context,
        activationId: string,
    ): Promise<void> => {
        const activation: IActivation = await activationRepository.getActivationById(
            activationId,
        );
        if (activation) {
            context.commit(mutations.STORE_ACTIVATION, activation);
        }
    },
    loadActivationCreateById: async (context, Id: number): Promise<void> => {
        const dashboard: IActivation[] = await dashboardRepository.getActivationById(
            Id,
        );
        context.commit(mutations.LOAD_ACTIVATIONCREATE, dashboard);
    },

    addActivation: async (context, payload: FormData): Promise<IActivationCreate> => {
        const Activations = await activationcreateRepository.add(payload);
        context.commit(mutations.ADD_ACTIVATION, Activations);

        return Activations;
    },

    editActivation: async (context, payload: FormData): Promise<IActivationCreate | IActivationCreate[]> => {
        const Activations = await activationcreateRepository.replace(payload);
        context.commit(mutations.EDIT_ACTIVATION, Activations);

        return Activations;
    },
    uploadFiles: async (
        context,
        payload: IUploadFile,
    ): Promise<void> => {
        const Upload = await uploadFileRepository.add(payload);

        context.commit(mutations.UPLOAD_FILE, Upload);
    },
    loadAllActivations: async ({ commit }) => {
        const activations = await activationRepository.getActivations();
        commit(mutations.GET_ALL_ACTIVATIONS, activations);
    },
    loadAllKeywords: async ({ commit }) => {
        const keywords = await keywordRepository.getKeywords();

        commit(mutations.GET_ALL_KEYWORDS, keywords);
    },
    loadAllHashtags: async ({ commit }) => {
        const hashtags = await hashtagRepository.getHashtags();

        commit(mutations.GET_ALL_HASHTAGS, hashtags);
    },
    updateActivationProviderAccess: async (context, accessUpdate: IActivationAccessUpdate) => {
        const canAccess = await activationRepository.updateProviderAccess(accessUpdate.activationId.toString(), accessUpdate.canAccess);
        const newAccessData = { ...accessUpdate, canAccess };
        context.commit(mutations.SET_ACTIVATION_CAN_PROVIDER_ACCESS, newAccessData);
    },
    updateActivationLiveState: async (context, activationId: number) => {
        await activationRepository.updateStatusToLive(activationId.toString());
        context.commit(mutations.SET_ACTIVATION_IS_LIVE, activationId);
    },
    deleteActivation: async (context, activationId: number) => {
        await activationRepository.deleteActivation(activationId.toString());
        context.commit(mutations.SET_ACTIVATION_DELETE, activationId);
    },
    loadActivationComments: async (context, activationId: number): Promise<void> => {
        const comments: IActivationComment[] = await activationCommentRepository.getComments(activationId);
        context.commit(mutations.LOAD_ACTIVATION_COMMENTS, comments);
    },
    addActivationComment: async (context, payload): Promise<void> => {
        const comment: IActivationComment = await activationCommentRepository.addComment(payload.activationId, payload);
        context.commit(mutations.ADD_ACTIVATION_COMMENT, comment);
    },
    loadActivationUsers: async (context, activationId: number): Promise<void> => {
        const users: IActivationUser[] = await activationRepository.getActivationUsers(activationId);
        context.commit(mutations.LOAD_ACTIVATIONS_USERS, users);
    },
    upsertActivationUserPermissions: async (context, activationUsers: IUpsertActivationUsers): Promise<void> => {
        await activationRepository.upsertActivationUser(activationUsers);
        context.commit(mutations.UPSERT_ACTIVATION_USERS, activationUsers.users);
    },
};
